module.exports = __webpack_public_path__ + "img/menu-hair-2.f9ca4326.jpg";